import React from 'react';
import ReactDOMServer from "react-dom/server";
import { locHtml } from "../locHtml";

const trainingCircle = (t: (key: string) => string) => <div className="new-quote-container centered">
  <div className="splash-icon">⭕</div>
  <div className="splash-header">
    <h1 className="no-word-break">{t("splash.gymBuddy.trainingCircle.title")}</h1>
    <div className="quote">
      {t("splash.gymBuddy.trainingCircle.text")}
    </div>
  </div>
</div>;

const trainingCircleElement = {
  name: 'training-circle',
  type: 'html',
  html: locHtml((t) => ReactDOMServer.renderToStaticMarkup(trainingCircle(t))),
}

export default trainingCircleElement;
